import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { IntroCard } from './intro-card.model';
import { IntroCardsProvider } from './intro-cards.provider';
import { linkPath, linkQuery } from '@services/module-access.logic';
import { UsersService } from '@services/users.service';
import { setForcePasswordChangeFlag } from '../util/auth/helpers';
import { brand } from '@app/branding/brand';
import { HeaderNavService } from '@layout/header-nav/header-nav.service';
import { Header } from '@layout/header-nav/Header';

/**
 * Intro / landing de la suite (deck SUIT INPROVIDER, lámina 4).
 *
 * Implementación NUEVA que reemplaza a `IntroComponent`: presenta las tarjetas
 * de módulos en grid, como el deck. Responsabilidad única (SRP): pintar las
 * `IntroCard` que le da el provider y navegar. No conoce el catálogo del
 * sidebar ni el domain config (DIP): depende de la abstracción `IntroCard`.
 */
@Component({
  selector: 'app-intro-suite',
  templateUrl: './intro-suite.component.html',
  styleUrls: ['./intro-suite.component.scss'],
  standalone: false,
})
export class IntroSuiteComponent implements OnInit {
  private readonly cardsProvider = inject(IntroCardsProvider);
  private readonly users = inject(UsersService);
  private readonly router = inject(Router);
  private readonly headerNav = inject(HeaderNavService);

  readonly brandName = brand.name;
  readonly isTrBrand = brand.id === 'tr';

  cards: IntroCard[] = [];
  linkPath = linkPath;
  linkQuery = linkQuery;

  ngOnInit(): void {
    this.cards = this.cardsProvider.getCards();
    Promise.resolve().then(() => {
      this.headerNav.changeOption(new Header({
        name: 'Intro',
        icon: 'inp-icon-flows-o',
        link: '/intro',
        visible: false,
      }));
    });
    // Mismo guard de cambio de contraseña forzado que el intro anterior: si el
    // backend lo pide, se redirige antes de dejar navegar.
    this.users.getDataUser().subscribe((data: any) => {
      if (data?.result?.forcePasswordChange) {
        setForcePasswordChangeFlag(true);
        this.router.navigate(['/change-password']);
      }
    });
  }

  trackByKey(_index: number, card: IntroCard): string {
    return card.key;
  }
}
